<template lang="slm">
.container
	.columns
		.column.is-8.is-offset-2
			h1 style="text-align: center;"
				br
				| 😟
			h2 style="text-align: center;" Kunne ikke finne siden.
</template>

<script>

export default {
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/FourOFour.vue